import { useEffect } from "react";
import classNames from "classnames";
import styles from "./AboutUs.module.css";
import { CheckboxList, HeaderSection, DirectorHeader } from "@cpnw/ui";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderBod = (bod) => {
    const { name, position, jobTitle, org, email } = bod;
    return (
      <>
        <DirectorHeader name={name} position={position} />
        <br />
        {jobTitle}
        <br />
        {org && (
          <>
            {org}
            <br />
            <br />
          </>
        )}
        {email && (
          <>
            <a href={`mailto:${email}`}>{email}</a>
            <br />
            <br />
          </>
        )}
      </>
    );
  };

  return (
    <section className={styles.aboutUs}>
      <HeaderSection header={"Partners for excellence in clinical education."} />
      <div className={classNames(styles.row)}>
        <div className={classNames(styles.column)}><p>Clinical Placements Northwest (CPNW) is a not-for-profit corporation working to facilitate clinical placement for the Health Professions student, to increase availability of student placement opportunities, and to improve communication among healthcare organizations and nursing education programs in Washington State and Northern Idaho. We presently have 53 member organizations; 19 healthcare partners, and 33 partners in education. CPNW collaborates with numerous education programs throughout the Pacific Northwest. Our education and healthcare partners are working together with a shared vision and common goal of creating a well-prepared and competent healthcare workforce. Learn about our extensive list of participating programs in the links to the left.</p></div>
      </div>
      <div className={classNames(styles.row)}>
        <div className={classNames(styles.column)}>
          <p>
            <strong>Our Mission</strong> is to improve the health education and
            clinical experience, thereby increasing value to
            all stakeholders; improving quality of care;
            improving patient, student and preceptor
            satisfaction; and promoting system sustainability.
          </p>
          <p>
            <strong>Our Goal</strong> is to be the recognized leader in innovation in clinical placement of the health professions student.
          </p></div>
        <div className={classNames(styles.column)}>
          <strong> We intend </strong>to reach our goal and accomplish our mission by:
          <CheckboxList items={[
            { description: "Creating efficient & effective systems", isChecked: true, readOnly: true },
            { description: "Streamlining & standardizing processes across organizations", isChecked: true, readOnly: true },
            { description: "Ensuring compliance", isChecked: true, readOnly: true },
            { description: "Promoting relationships", isChecked: true, readOnly: true },
            { description: "Demonstrating resource savings", isChecked: true, readOnly: true },
            { description: "Sharing best practices for sustainable improvement", isChecked: true, readOnly: true },
          ]} />
        </div>
      </div>
      <HeaderSection header={"CPNW Board of Directors"} />
      <div className={classNames(styles.row)}>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Karalynn LaValley"])}
        </div>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Shelly Caldejon"])}
        </div>
      </div>
      <div className={classNames(styles.row)}>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Julie Baxter"])}
        </div>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Tiffany Smith-Fromm"])}
        </div>
      </div>
      <div className={classNames(styles.row)}>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Antwinett O. Lee"])}
        </div>
        <div className={classNames(styles.column)}>
          {renderBod(bods["Jolita Perez"])}
        </div>
      </div>
    </section>
  );
};

const bods = {
  "Karalynn LaValley": {
    name: "Karalynn LaValley",
    position: "Past President",
    jobTitle: "Associate Dean of Nursing and Healthcare Studies",
    org: "Green River College",
  },
  "Shelly Caldejon": {
    name: "Shelly Caldejon",
    position: "President",
    jobTitle: "Lead Professional Development Specialist",
    org: "UW Medicine/Valley Medical Center",
  },
  "Julie Baxter": {
    name: "Julie Baxter",
    position: "At-Large",
    jobTitle: "Division Clinical Program Manager, Academic Services",
    org: "Providence-Swedish, North Division Education & Professional Practice Team",
  },
  "Tiffany Smith-Fromm": {
    name: "Tiffany Smith-Fromm MN, RN",
    position: "Member at Large",
    jobTitle: "Dean of Instruction - Nursing Programs",
    org: "Clover Park Technical College",
  },
  "Antwinett O. Lee": {
    name: "Antwinett O. Lee EdD, MSN-CNS, BSN, RN",
    position: "Vice President",
    jobTitle: "Interim Chief Nurse Administrator",
    org: "Seattle Pacific University",
  },
  "Jolita Perez": {
    name: "Jolita Perez MBA, MHML, LPN",
    position: "Treasurer",
    jobTitle: "Manager - Workforce & Student Development, System",
    org: " ",
  },
};

export default AboutUs;
